/* global angular */
( function () {
	'use strict';

	/* @ngInject */
	function loadTemplateMask ( indicatorService ) {
		function filterTagMapper ( tag ) {
			return {
				'tagName' : tag
			};
		}

		function filterMapper ( filter ) {
			var key = Object.keys( filter )[ 0 ];

			return {
				'filterName' : key,
				'children'   : filter[ key ].map( filterTagMapper )
			};
		}

		function attachmentsMapper ( attachments ) {
			attachments.ContentId   = attachments.id;
			attachments.ContentName = attachments.name;
			return attachments;
		}

		function indicatorMapper ( indicator ) {
			indicator.templateAttachments = ( indicator.templateAttachments || [] ).map( attachmentsMapper );
			angular.extend( indicator, indicatorService.getConfig( indicator.type.toString() ) );

			return indicator;
		}

		function rubricMapper ( model ) {
			return {
				'optionText'  : model.title,
				'description' : model.description,
				'value'       : model.maxRange
			};
		}

		function processRubric ( model, targetModel ) {
			if ( !angular.isUndefined( model.rubric ) && Array.isArray( model.rubric ) ) {
				targetModel.rubric = {
					'answerOptions' : model.rubric.map( rubricMapper )
				};
			}
		}

		function groupMapper ( group ) {
			var groupModel = {
				'groupName'           : group.name,
				'id'                  : group.id,
				'indicators'          : group.indicators.map( indicatorMapper ),
				'templateAttachments' : ( group.templateAttachments || [] ).map( attachmentsMapper )
			};

			if ( group.formula ) {
				groupModel.formula = group.formula;
			}

			processRubric( group, groupModel );

			return groupModel;
		}

		// TODO - API still too volatile, apply mask for changing API needs. When abit stable apply final mask to actual code
		function unpack ( model ) {
			var unpackedModel = {
				'template' : {
					'name' : model.name
				},
				'allowSignature'      : model.allowSignature,
				'types'               : model.types,
				'tags'                : model.tags.map( filterMapper ),
				'groups'              : model.groups.map( groupMapper ),
				'formula'             : model.formula,
				'creator'             : model.creator,
				'templateId'          : model.id,
				'templateAttachments' : model.templateAttachments,
				'originId'            : model.originId,
				'parentId'            : model.parentId,
				'hideScoring'         : model.hideScoring,
				'templateReferences'  : model.templateReferences || []
			};

			processRubric( model, unpackedModel );

			return unpackedModel;
		}

		return {
			'unpack'        : unpack,
			'processRubric' : processRubric
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'loadTemplateMask', loadTemplateMask );

	loadTemplateMask.$inject = [ 'indicatorService' ];
} )( );
